import { createMemo, createResource } from "solid-js";
import { useRouteData } from "solid-start";
import * as dateMath from "date-arithmetic";
import { Typography } from "./Expires.styles";

import { routeData } from "~/routes";

type ExpiresType = {
  expires: number;
  blockheight: number;
};

export function Expires(props: ExpiresType) {
  const { expires, blockheight } = props;

  const difference = expires - blockheight;
  const time_in_minutes = difference * 1;
  const timeExpires = dateMath.add(new Date(), time_in_minutes, "minutes").toLocaleDateString("en-US", {
    month: 'short',
    day: 'numeric',
    year: 'numeric'
  });

  return (
    <Typography>{timeExpires}</Typography>
  );
}
